
const SizingChart = {
	"Center Console": [
		{
			"beam": 2.438,
			"options": [
				{
					"maxLength": 12.801,
					"recommend": 2
				},
				{
					"maxLength": 14.934,
					"recommend": 3
				}
			]
		},
		{
			"beam": 2.743,
			"options": [
				{
					"maxLength": 11.277,
					"recommend": 2
				},
				{
					"maxLength": 14.630,
					"recommend": 3
				},
				{
					"maxLength": 14.934,
					"recommend": 6
				}
			]
		},
		{
			"beam": 3.048,
			"options": [
				{
					"maxLength": 10.058,
					"recommend": 2
				},
				{
					"maxLength": 13.106,
					"recommend": 3
				},
				{
					"maxLength": 14.934,
					"recommend": 6
				}
			]
		},
		{
			"beam": 3.353,
			"options": [
				{
					"maxLength": 9.144,
					"recommend": 2
				},
				{
					"maxLength": 11.887,
					"recommend": 3
				},
				{
					"maxLength": 14.934,
					"recommend": 6
				}
			]
		},
		{
			"beam": 3.657,
			"options": [
				{
					"maxLength": 8.534,
					"recommend": 2
				},
				{
					"maxLength": 10.972,
					"recommend": 3
				},
				{
					"maxLength": 14.934,
					"recommend": 6
				}
			]
		},
		{
			"beam": 3.962,
			"options": [
				{
					"maxLength": 10.058,
					"recommend": 3
				},
				{
					"maxLength": 14.934,
					"recommend": 6
				}
			]
		},
		{
			"beam": 4.267,
			"options": [
				{
					"maxLength": 9.448,
					"recommend": 3
				},
				{
					"maxLength": 14.934,
					"recommend": 6
				}
			]
		}
	],
	"Express": [
		{
			"beam": 2.438,
			"options": [
				{
					"maxLength": 12.801,
					"recommend": 2
				},
				{
					"maxLength": 14.934,
					"recommend": 3
				}
			]
		},
		{
			"beam": 2.743,
			"options": [
				{
					"maxLength": 11.582,
					"recommend": 2
				},
				{
					"maxLength": 14.630,
					"recommend": 3
				},
				{
					"maxLength": 14.934,
					"recommend": 6
				}
			]
		},
		{
			"beam": 3.048,
			"options": [
				{
					"maxLength": 10.363,
					"recommend": 2
				},
				{
					"maxLength": 13.106,
					"recommend": 3
				},
				{
					"maxLength": 14.934,
					"recommend": 6
				}
			]
		},
		{
			"beam": 3.353,
			"options": [
				{
					"maxLength": 9.448,
					"recommend": 2
				},
				{
					"maxLength": 11.887,
					"recommend": 3
				},
				{
					"maxLength": 14.934,
					"recommend": 6
				}
			]
		},
		{
			"beam": 3.657,
			"options": [
				{
					"maxLength": 8.534,
					"recommend": 2
				},
				{
					"maxLength": 10.972,
					"recommend": 3
				},
				{
					"maxLength": 14.934,
					"recommend": 6
				}
			]
		},
		{
			"beam": 3.962,
			"options": [
				{
					"maxLength": 7.924,
					"recommend": 2
				},
				{
					"maxLength": 10.058,
					"recommend": 3
				},
				{
					"maxLength": 14.934,
					"recommend": 6
				}
			]
		},
		{
			"beam": 4.267,
			"options": [
				{
					"maxLength": 9.144,
					"recommend": 3
				},
				{
					"maxLength": 14.934,
					"recommend": 6
				}
			]
		}
	],
	"Cruiser": [
		{
			"beam": 2.438,
			"options": [
				{
					"maxLength": 12.801,
					"recommend": 2
				},
				{
					"maxLength": 14.934,
					"recommend": 3
				}
			]
		},
		{
			"beam": 2.743,
			"options": [
				{
					"maxLength": 11.582,
					"recommend": 2
				},
				{
					"maxLength": 14.630,
					"recommend": 3
				},
				{
					"maxLength": 14.934,
					"recommend": 6
				}
			]
		},
		{
			"beam": 3.048,
			"options": [
				{
					"maxLength": 10.363,
					"recommend": 2
				},
				{
					"maxLength": 13.106,
					"recommend": 3
				},
				{
					"maxLength": 14.934,
					"recommend": 6
				}
			]
		},
		{
			"beam": 3.353,
			"options": [
				{
					"maxLength": 9.448,
					"recommend": 2
				},
				{
					"maxLength": 11.887,
					"recommend": 3
				},
				{
					"maxLength": 14.934,
					"recommend": 6
				}
			]
		},
		{
			"beam": 3.657,
			"options": [
				{
					"maxLength": 8.534,
					"recommend": 2
				},
				{
					"maxLength": 10.972,
					"recommend": 3
				},
				{
					"maxLength": 14.934,
					"recommend": 6
				}
			]
		},
		{
			"beam": 3.962,
			"options": [
				{
					"maxLength": 7.924,
					"recommend": 2
				},
				{
					"maxLength": 10.058,
					"recommend": 3
				},
				{
					"maxLength": 14.934,
					"recommend": 6
				}
			]
		},
		{
			"beam": 4.267,
			"options": [
				{
					"maxLength": 9.144,
					"recommend": 3
				},
				{
					"maxLength": 14.934,
					"recommend": 6
				}
			]
		}
	]
};

export default SizingChart;



// WEBPACK FOOTER //
// ./src/utils/SizingChart.js